// src/lib/invoicesAuxCache.js
const KEY = "invoices_aux_cache_v1";
const TTL = 10 * 60 * 1000; // 10 min

export function readInvoicesAuxCache() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed) return null;
    if (Date.now() - (parsed.ts || 0) > TTL) return null;
    return parsed.data || null;
  } catch {
    return null;
  }
}

export function writeInvoicesAuxCache(data) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), data }));
  } catch {}
}
